"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function veri(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M4.5 6.00009C5.328 6.00159 6.15675 6.00159 6.984 6.00009L8.55225 14.3851C8.577 14.5088 8.607 14.6311 8.63925 14.7526C8.76225 14.2651 8.8395 13.7671 8.94225 13.2751L10.3702 6.00009L12.7733 6.00084C11.892 9.92484 11.0107 13.8496 10.128 17.7736H7.14525C6.2625 13.8518 5.38125 9.93009 4.5 6.00759V6.00009ZM13.7355 9.69909C14.2582 9.04209 15.0938 8.74434 15.8993 8.69184C16.6942 8.63634 17.5507 8.70834 18.2242 9.18234C18.8205 9.59934 19.1475 10.3043 19.3027 11.0056C19.491 11.8846 19.5007 12.7876 19.5 13.6831H15.0975C15.1012 14.3453 15.06 15.0286 15.2812 15.6631C15.3885 15.9751 15.5887 16.2856 15.9067 16.3988C16.2457 16.5091 16.6537 16.4371 16.9012 16.1641C17.2312 15.7906 17.3003 15.2671 17.3722 14.7878H19.3702C19.3252 15.5828 19.1783 16.4228 18.6578 17.0476C18.1358 17.6971 17.2942 17.9626 16.4977 17.9948C15.6322 18.0278 14.6925 17.9101 14.0025 17.3273C13.3612 16.7926 13.0815 15.9451 12.9705 15.1328C12.8595 14.1976 12.8535 13.2511 12.9053 12.3113C12.975 11.3948 13.1407 10.4243 13.7347 9.69834L13.7355 9.69909ZM15.441 10.6328C15.1005 11.1233 15.0915 11.7548 15.0975 12.3331H17.3715C17.3363 11.7833 17.34 11.2028 17.0925 10.6996C16.785 10.0786 15.813 10.0763 15.4425 10.6336H15.441V10.6328Z", fill: color }));
}
exports["default"] = veri;
//# sourceMappingURL=veri.js.map